export default __webpack_public_path__ + "static/media/number2.a5ca9c94.png";